import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  padding: 30px !important;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  h1 {
    ${props => props.theme.css.heading3};
    width: 100%;
    text-align: center;
  }
`

export const TableWrapper = styled.div<{isPDF: boolean}>`
  width: 100%;
  padding: ${props => props.isPDF ? '0' : '20px 0'};

  h3 {
    font: ${props => font('default', 'normal', props.isPDF ? '25px' : '40px/1.5')};
    margin-bottom: 10px;
    ${props => props.isPDF && `
      margin-top: 20px;
    `}
  }
`

export const Actions = styled.div`
  margin-top: 40px;
  ${bp('sm')`
    text-align: center;
  `}

  button,
  a {
    ${props => props.theme.css.buttonPrimary};
    margin: 5px 10px;
  }
`

export const ChartWrapper = styled.div<{isPDF: boolean}>`
  height: ${props => props.isPDF ? '280px' : '500px'};
  max-width: ${props => props.isPDF ? '300px' : '500px'};
  width: 100%;
  margin: 10px auto 50px;
`
